<div class="row js-hide-on-fullscreen">
    <div class="col-xs-12">
        <label class="control-label">{{TR "Aktiver Gerätefilter"}}</label>
    </div>
</div>
<div class="row js-hide-on-fullscreen">
    <div class="col-xs-1">
        <div class="btn-group">
            <div class="btn btn-white btn-sm js-edit-filter">
                <i class="fa fa-pencil" />
            </div>
            {{#if showClear}}
            <div class="btn btn-white btn-sm js-reset-filter">
                <i class="fa fa-trash" />
            </div>
            {{/if}}
        </div>
    </div>
    <div class="col-xs-11">
        {{{filterText}}}
    </div>
</div>
